<template>
  <div>
    <div v-show="isLoading" v-loading="isLoading" class="page-loading"></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isLoading: false
      }
    },
    watch: {
      '$store.state.routers.isLoading'(val) {
        this.isLoading = val
      }
    }
  };
</script>

<style lang="scss">
  .page-loading {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9999999999 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/loading.vue